import * as Types from 'src/actions/project/index-person-interested/Types';
import Project from 'src/entities/Project';
import {
  IndexPersonInterestedProjectsAction
} from 'src/actions/project/index-person-interested/IndexPersonInterestedProjects.actions';

export interface IndexPersonInterestedProjectsState {
  projects: Project[];
  loading: boolean;
  error: boolean;
}

const initialState: IndexPersonInterestedProjectsState = {
  projects: [],
  loading: false,
  error: false,
};

export function IndexPersonInterestedProjectsReducer(
  state: IndexPersonInterestedProjectsState = initialState,
  action: IndexPersonInterestedProjectsAction
  ): IndexPersonInterestedProjectsState {
  switch (action.type) {
    case Types.INDEX_PERSON_INTERESTED_PROJECTS_ATTEMPT:
      return { ...state, projects: [], loading: true, error: false };
    case Types.INDEX_PERSON_INTERESTED_PROJECTS_SUCCESS:
      const projects = action.payload;
      return { ...state, projects: projects, loading: false, error: false };
    case Types.INDEX_PERSON_INTERESTED_PROJECTS_FAILURE:
      return { ...state, projects: [], loading: false, error: true };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/project/IndexPersonInterestedProjects.reducer.tsx